import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { useLoader } from "../../../utils/common";
import ImpactImages from "./Impactimages";

const API_URL = "/admin/about-us/impact";

const EditImpact = ({ id, handleClose }) => {
  const { getData, IMG_URL } = useContext(Context);
  const { withLoader } = useLoader();
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [existing, setExisting] = useState([]); // saved images [{id, image}]
  const [removeIds, setRemoveIds] = useState([]);
  const [files, setFiles] = useState([]); // newly picked

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    (async () => {
      const response = await withLoader(() => getData(`${API_URL}/${id}`));
      const d = { ...(response?.data || {}) };
      setExisting((d.images || []).map((i) => ({ id: i.id, image: i.image })));
      delete d.images;
      delete d.image;
      reset(d);
    })();
    // eslint-disable-next-line
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("description", data.description);
      sendData.append("sort_order", data.sort_order || 0);
      // saved images that stay, in the chosen order (first = thumbnail), and the ones to delete
      sendData.append("image_order", JSON.stringify(existing.map((i) => i.id)));
      sendData.append("remove_image_ids", JSON.stringify(removeIds));
      // new images are added after the saved ones
      files.forEach((f) => sendData.append("images", f));

      const response = await withLoader(() => putData(`${API_URL}/${id}`, sendData));
      setShowModal({ code: response?.code, message: response?.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        if (response?.success) handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Edit Impact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()} role="form">
            <Row className="justify-content-center">
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Description"
                        className={classNames("w-100", { "is-invalid": errors?.description })}
                        {...register("description", { required: "Description is required" })}
                      />
                    </InputGroup>
                    {errors.description && <span className="text-danger">{errors.description.message}</span>}
                  </Form.Group>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Images</Form.Label>
                    <ImpactImages
                      existing={existing}
                      setExisting={setExisting}
                      removeIds={removeIds}
                      setRemoveIds={setRemoveIds}
                      files={files}
                      setFiles={setFiles}
                      base={IMG_URL}
                    />
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Display Order</Form.Label>
                    <InputGroup className="d-block">
                      <Form.Control type="number" min={0} className="w-100" {...register("sort_order")} />
                    </InputGroup>
                    <small className="text-muted">Lower numbers show first.</small>
                  </Form.Group>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton name={"Cancel"} handleClose={handleClose} />
                  </Link>
                  <SaveButton name={"Save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave message={showModal.message} showErrorModal={showModal.code ? true : false} />
    </>
  );
};

export default EditImpact;